import { connect } from 'react-redux'
import Component from 'components/Contact'

export default connect()(Component)
